<template>
    <div class="accountData">
        <Page :showAdd="isAdd" disabledAdd showAddText="新增推广商品" :renderSearchList="renderList" :searchData="searchData" :tableData="tableData" :total="total" :current="current" :pageSize="pageSize" @changeCurrrent="handleChangeCurrrent" @changePageSize="handleChangePageSize" @changeSearchDat="handleChangeSearchData" @search="handleSearch" @add="handleClickAdd">
            <div class="table-content" ref="tableContent" :style="`height: ${tableHeight}px`">
                <Table :data="tableData" size="medium" stripe v-if="tableData.length && !isLoading" :height="tableHeight">
                    <el-table-column prop="goodsId" label="推广ID" width="130"></el-table-column>
                    <el-table-column prop="customerName" label="归属客户" width="120"></el-table-column>
                    <el-table-column prop="platAppName" label="归属店铺" width="120"></el-table-column>
                    <el-table-column prop="adGoodsId" label="商品ID" width="140"></el-table-column>
                    <el-table-column prop="goodsName" label="商品标题" min-width="140"></el-table-column>
                    <el-table-column prop="adPlatName" label="引流平台" width="72"></el-table-column>
                    <el-table-column prop="adReportOrderStatusText" label="推广目标" width="72"></el-table-column>
                    <el-table-column prop="adReportEventName" label="回传转化事件" width="160"></el-table-column>
                    <el-table-column prop="status" label="状态" width="72">
                        <template slot-scope="scope">
                            <div>
                                <span style="color: #67c23a; font-size: 12px;" v-if="scope.row.status == 1">推广中</span>
                                <span style="color: #FF003C; font-size: 12px;" v-else-if="scope.row.status == 2">已关闭</span>
                                <span v-else>--</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="notes" label="备注" min-width="140"></el-table-column>
                    <el-table-column prop="status" label="商品链接" width="80">
                        <template slot-scope="scope">
                            <div>
                                <span style="color: #0061E4; font-size: 12px; cursor: pointer;" @click="handleViewGood(scope.row.platGoodsLink)">查看商品</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="status" label="一跳链接" width="106">
                        <template slot-scope="scope">
                            <div>
                                <span style="color: #0061E4; font-size: 12px; cursor: pointer;" @click="handleCopyLink(scope.row.adDeepLink)">复制一跳链接</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="status" label="落地页链接" width="110">
                        <template slot-scope="scope">
                            <div>
                                <Poptip trigger="hover" :width="400" :placement="'bottom'">
                                    <span style="color: #0061E4; font-size: 12px; cursor: pointer;" @click="handleCopyLink(scope.row.adClickLink)">复制落地页链接</span>
                                    <template #content>
                                        <div class="wf-form-item-tip">
                                            <span>淘宝暂时不支持单独推广二跳落地页，必须配置一跳链接(直达链接)</span>
                                            <!-- <a target="_blank" :href="'https://www.baidu.com/'"></a> -->
                                        </div>
                                    </template>
                                </Poptip>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="adFeedClickLink" label="点击监测链接" width="120">
                        <template slot-scope="scope">
                            <div>
                                <span style="color: #0061E4; font-size: 12px; cursor: pointer;" @click="handleCopyLink(scope.row.adFeedClickLink)">复制点击监测链接</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="adTjmDeepLink" label="淘积木一跳" width="130">
                        <template slot-scope="scope">
                            <div>
                                <span v-if="scope.row.adTjmDeepLink" style="color: #0061E4; font-size: 12px; cursor: pointer;" @click="handleCopyLink(scope.row.adTjmDeepLink)">复制淘积木一跳链接</span>
                                <span v-else style="font-size: 12px;">未配置</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column v-if="isAdd" prop="adReportOrderStatus" label="操作" width="88">
                        <template slot-scope="scope">
                            <div style="opacity: .3; cursor: not-allowed;  " class="table-edit" @click="handleEdit(scope.row)">
                                <img src="../../../../assets/home/userInfo/customerManage/edit_select.png" alt="">
                                <span>编辑</span>
                                <!-- {{scope.row.adReportOrderStatus == 1 ? '下单' : (scope.row.adReportOrderStatus == 2 ? '支付' : '--')}} -->
                            </div>

                            <!-- <div style="margin-left: 24px;" class="table-edit" @click="handleRefresh(scope.row)">
                                <img src="../../../../assets/home/userInfo/customerManage/refresh.png" alt="">
                                <span>刷新链接</span>
                            </div> -->
                        </template>
                    </el-table-column>
                </Table>

                <div class="table-normal" v-if="!tableData.length && !isLoading">
                    <img src="@/assets/home/dataEffect/accountData/default_img_no_data.png" alt="">
                    <span>目前暂无数据</span>
                </div>

                <div v-if="isLoading">
                    <LoadingComponent></LoadingComponent>
                </div>
            </div>
        </Page>

        <Dialog v-model="isShow" width="550px" :title="title" @cancel="handleCancel" @confirm="handleConfirm">
            <div class="accountData-form">
                <Form :labelWidth="180" ref="customerManage-form" :renderList="formRenderList" v-model="addFormData" :rules="formRules" @changeForm="handleChangeForm" @blur="handleBlur"></Form>
            </div>
        </Dialog>

        <div :class="`accountData-mobile`">
            <PageMobile title="淘宝商品管理" :renderSearchList="renderMobileList" :searchData="searchData" :total="total" :current="current" :pageSize="pageSize" @changeCurrrent="handleChangeCurrrent" @search="handleSearch" showAdd addText="新增推广商品" @add="handleClickAdd" disabledAdd>
                <div class="table-content" ref="tableContentMobile" :style="`height: ${tableHeight}px`">
                    <Table :data="tableData" size="small" :height="tableHeight" stripe v-if="tableData.length && !isLoading">
                        <el-table-column prop="goodsId" label="推广ID" width="130"></el-table-column>
                        <el-table-column prop="customerName" label="归属客户" width="120"></el-table-column>
                        <el-table-column prop="platAppName" label="归属店铺" width="120"></el-table-column>
                        <el-table-column prop="adGoodsId" label="商品ID" width="140"></el-table-column>
                        <el-table-column prop="goodsName" label="商品标题" min-width="140"></el-table-column>
                        <el-table-column prop="adPlatName" label="引流平台" width="72"></el-table-column>
                        <el-table-column prop="adReportOrderStatusText" label="推广目标" width="72"></el-table-column>
                        <el-table-column prop="adReportEventName" label="回传转化事件" width="160"></el-table-column>
                        <el-table-column prop="status" label="状态" width="72">
                            <template slot-scope="scope">
                                <div>
                                    <span style="color: #67c23a; font-size: 12px;" v-if="scope.row.status == 1">推广中</span>
                                    <span style="color: #FF003C; font-size: 12px;" v-else-if="scope.row.status == 2">已关闭</span>
                                    <span v-else>--</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="notes" label="备注" min-width="140"></el-table-column>
                        <el-table-column prop="status" label="商品链接" width="80">
                            <template slot-scope="scope">
                                <div>
                                    <span style="color: #0061E4; font-size: 12px; cursor: pointer;" @click="handleViewGood(scope.row.platGoodsLink)">查看商品</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="status" label="一跳链接" width="106">
                            <template slot-scope="scope">
                                <div>
                                    <span style="color: #0061E4; font-size: 12px; cursor: pointer;" @click="handleCopyLink(scope.row.adDeepLink)">复制一跳链接</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="status" label="落地页链接" width="110">
                            <template slot-scope="scope">
                                <div>
                                    <Poptip trigger="hover" :width="400" :placement="'bottom'">
                                        <span style="color: #0061E4; font-size: 12px; cursor: pointer;" @click="handleCopyLink(scope.row.adClickLink)">复制落地页链接</span>
                                        <template #content>
                                            <div class="wf-form-item-tip">
                                                <span>淘宝暂时不支持单独推广二跳落地页，必须配置一跳链接(直达链接)</span>
                                                <!-- <a target="_blank" :href="'https://www.baidu.com/'"></a> -->
                                            </div>
                                        </template>
                                    </Poptip>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="adFeedClickLink" label="点击监测链接" width="120">
                            <template slot-scope="scope">
                                <div>
                                    <span style="color: #0061E4; font-size: 12px; cursor: pointer;" @click="handleCopyLink(scope.row.adFeedClickLink)">复制点击监测链接</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="adTjmDeepLink" label="淘积木一跳" width="130">
                            <template slot-scope="scope">
                                <div>
                                    <span v-if="scope.row.adTjmDeepLink" style="color: #0061E4; font-size: 12px; cursor: pointer;" @click="handleCopyLink(scope.row.adTjmDeepLink)">复制淘积木一跳链接</span>
                                    <span v-else style="font-size: 12px;">未配置</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="isAdd" prop="adReportOrderStatus" label="操作" width="88">
                            <template slot-scope="scope">
                                <div style="opacity: .3; cursor: not-allowed;  " class="table-edit" @click="handleEdit(scope.row)">
                                    <img src="../../../../assets/home/userInfo/customerManage/edit_select.png" alt="">
                                    <span>编辑</span>
                                    <!-- {{scope.row.adReportOrderStatus == 1 ? '下单' : (scope.row.adReportOrderStatus == 2 ? '支付' : '--')}} -->
                                </div>

                                <!-- <div style="margin-left: 24px;" class="table-edit" @click="handleRefresh(scope.row)">
                                <img src="../../../../assets/home/userInfo/customerManage/refresh.png" alt="">
                                <span>刷新链接</span>
                            </div> -->
                            </template>
                        </el-table-column>
                    </Table>

                    <div class="table-normal" v-if="!tableData.length && !isLoading">
                        <img src="@/assets/home/dataEffect/accountData/default_img_no_data.png" alt="">
                        <span>目前暂无数据</span>
                    </div>

                    <div v-if="isLoading">
                        <LoadingComponent></LoadingComponent>
                    </div>
                </div>
            </PageMobile>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import Page from '@/components/page/page.vue'
import PageMobile from '@/components/pageMobile/pageMobile.vue'
import Dialog from '@/components/dialog/dialog.vue'
import Form from '@/components/form/form.vue'
import Icon from 'iview/src/components/icon';
import { Table, TableColumn, Loading } from 'element-ui';
import LoadingComponent from '@/components/loading/loading.vue'
import { Message } from 'iview'
import { userRoleDict } from '../../config'
import { adPlatOptions, adReportEventOptions } from '../taobao/config'
import { adPlatMap, adReportOrderStatusMap, adReportEventMap, phAppIncMap } from '../../../../utils/map'
import { vailNumber } from '../../../../utils/reg'
Vue.use(Table)
Vue.use(TableColumn)
import { renderList, renderMobileList, formRenderList, formRules } from './config'
import Poptip from 'iview/src/components/poptip';
import moment from 'moment'
export default {
    components: {
        Page,
        Icon,
        Table,
        LoadingComponent,
        PageMobile,
        Dialog,
        Form,
        Poptip
    },
    data() {
        return {
            renderList: renderList,
            formRenderList: formRenderList,
            renderMobileList: renderMobileList,
            tableData: [],
            searchData: {},
            isLoading: true,
            tableTotalData: {},
            total: 0,
            pageSize: 15,
            current: 1,
            tableHeight: "",
            addFormData: {},
            isShow: false,
            formRules: formRules,
            title: '新增推广商品',
            isAdd: false
        }
    },
    filters: {
        filtersCell(value) {
            if (value) {
                return value
            } else {
                return '-'
            }
        }
    },
    mounted() {
        this.tableHeight = this.$refs.tableContent ? (this.$refs.tableContent.offsetHeight ? this.$refs.tableContent.offsetHeight : 480) : ""
        if (window.innerWidth > 768) {
            this.tableHeight = this.$refs.tableContent ? this.$refs.tableContent.offsetHeight : ""
        } else {
            this.tableHeight = this.$refs.tableContentMobile ? this.$refs.tableContentMobile.offsetHeight : ""
        }
        this.initData()
        this.getTableData()
    },
    methods: {
        // 初始化页面数据
        initData() {
            const userInfo = localStorage.userInfo ? JSON.parse(localStorage.userInfo) : {}
            if (userInfo.userRoleId === userRoleDict.admin || userInfo.userRoleId === userRoleDict.operate) {
                this.isAdd = true
            }
            Promise.all([this.getAllCustomer(), this.getTBShop()]).then((result) => {
                const customerOptions = result[0].map((item) => {
                    return {
                        label: item.name,
                        value: item.customerId
                    }
                })
                const shopOptions = result[1].map((item) => {
                    return {
                        label: item.platAppName,
                        value: item.rebateAppId
                    }
                })
                this.$set(this.formRenderList[0], 'options', customerOptions)
                this.$set(this.formRenderList[1], 'options', shopOptions)
                this.$set(this.renderList[2], 'options', customerOptions)
                this.$set(this.renderMobileList[2], 'options', [{ label: '无', value: undefined }, ...customerOptions])
            })
        },

        // 获取所有客户
        getAllCustomer() {
            return new Promise((resolve, reject) => {
                this.$axios({
                    url: '/api/syn/rebateDataPlat/customer/all',
                    data: {
                    },
                    method: 'GET'
                }).then((res) => {
                    resolve(res.Data)
                })
            })
        },

        // 获取所有客户
        getTBShop() {
            return new Promise((resolve, reject) => {
                const userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {}
                this.$axios({
                    url: '/api/syn/rebateDataPlat/platApp/tb/list',
                    data: {
                        customerId: userInfo.customerId
                    },
                    method: 'GET'
                }).then((res) => {
                    resolve(res.Data)
                })
            })
        },

        // 获取商品数据
        getTableData() {
            this.isLoading = true
            this.$axios({
                url: '/api/syn/rebateDataPlat/goods/list',
                data: {
                    ...this.searchData,
                    goodsPlatId: 10,
                    current: this.current,
                    pageSize: this.pageSize
                },
                method: 'GET'
            }).then((res) => {
                if (Array.isArray(res.Data.data) && res.Data.data.length) {
                    this.tableData = res.Data.data.map((item) => {
                        item.adReportOrderStatusText = adReportOrderStatusMap[item.adReportOrderStatus]
                        return item
                    })
                } else {
                    this.tableData = []
                }
                this.total = res.Data.total
                this.$nextTick(() => {
                    this.isLoading = false
                })
            })
        },

        // 点击查看商品时触发
        handleViewGood(link) {
            window.open(link, "_blank");
        },

        // 处理复制一级链接/二级链接
        handleCopyLink(link) {
            var input = document.getElementById('copyInput')
            if (input) {
                input.value = link; // 修改文本框的内容
                input.select(); // 选中文本
                document.execCommand("copy"); // 执行浏览器复制命令
                Message.success('复制成功')
            } else {
                Message.success('复制失败')
            }
        },

        // 处理移动端搜索改变事件
        handleChangeSearchMobileData(data) {
            const currData = { ...data }
            delete currData.dates
            this.searchData = {
                ...currData
            }
        },

        // 处理取消新增/编辑推广商品事件
        handleCancel() {
            this.$refs['customerManage-form'].$refs['wf-form'].resetFields()
            this.isShow = false
        },

        // 处理点击编辑事件
        handleEdit(item) {
            return
            this.title = "编辑推广商品"
            this.addFormData = { ...item, adTjmH5Link: item.adTjmH5Link ? decodeURIComponent(item.adTjmH5Link) : "" }
            const formRenderItem = { ...this.formRenderList[0] }
            formRenderItem.disabled = true
            this.$set(this.formRenderList, 0, formRenderItem)
            this.handleChangeAdPlatId(item.adPlatId)
            this.isShow = true
        },

        // 点击刷新链接按钮时触发
        handleRefresh(item) {
            this.$axios({
                url: '/api/syn/rebateDataPlat/goods/refrehTransLink',
                data: {
                    id: item.id,
                },
                method: 'GET'
            }).then((res) => {
                this.getTableData()
                Message.success('刷新链接成功')
            })
        },

        // 表单数据改变时触发
        handleChangeForm(event) {
            const { formData, formItem } = event
            const addFormData = { ...this.addFormData }
            switch (formItem.key) {
                case "rebateAppId":
                    delete addFormData.adGoodsId
                    delete addFormData.goodsName
                    this.addFormData = addFormData
                    break
                case "adPlatId":
                    this.handleChangeAdPlatId(formData.adPlatId)
                    // const formRenderItem = { ...this.formRenderList[7] }
                    // if (formData.adPlatId == 400) {
                    //     this.$set(this.formRules.phAppIncId[0], 'required', true)
                    //     formRenderItem.isHide = false
                    //     addFormData.phAppIncId = 7
                    //     this.addFormData = addFormData
                    // } else if (formData.adPlatId == 6) {
                    //     formRenderItem.isHide = true
                    //     this.$set(this.formRules.phAppIncId[0], 'required', false)
                    //     delete addFormData.phAppIncId
                    //     this.addFormData = addFormData
                    // }
                    // this.$set(this.formRenderList, 7, formRenderItem)
                    break
            }
        },

        // 处理引流平台改变事件
        handleChangeAdPlatId(adPlatId) {
            const addFormData = { ...this.addFormData }
            const formRenderItem = { ...this.formRenderList[7] }
            const formRenderItemAdReport = { ...this.formRenderList[6] }
            const currAdReportEventOptions = []
            let isInside = false
            for (let i = 0; i < adPlatOptions.length; i++) {
                const adPlatOption = adPlatOptions[i]
                if (adPlatOption.value === adPlatId) {
                    for (let j = 0; j < adReportEventOptions.length; j++) {
                        const adReportEventOption = adReportEventOptions[j]
                        if (adReportEventOption.label.indexOf(adPlatOption.label) > -1) {
                            currAdReportEventOptions.push({ ...adReportEventOption })
                            if (adReportEventOption.value === addFormData.adReportEventId) {
                                isInside = true
                            }
                        }
                    }
                    formRenderItemAdReport.options = currAdReportEventOptions
                    if (!isInside) {
                        delete addFormData.adReportEventId
                    }
                    break
                }
            }
            if (adPlatId == 400) {
                this.$set(this.formRules.phAppIncId[0], 'required', true)
                formRenderItem.isHide = false
                addFormData.phAppIncId = 7
                this.addFormData = addFormData
            } else if (adPlatId == 6) {
                this.$set(this.formRules.phAppIncId[0], 'required', true)
                formRenderItem.isHide = false
                addFormData.phAppIncId = 20
                this.addFormData = addFormData
            } else {
                formRenderItem.isHide = true
                this.$set(this.formRules.phAppIncId[0], 'required', false)
                delete addFormData.phAppIncId
                this.addFormData = addFormData
            }
            this.$set(this.formRenderList, 6, formRenderItemAdReport)
            this.$set(this.formRenderList, 7, formRenderItem)
        },

        // 处理失焦事件
        handleBlur(formItem) {
            if (formItem.key === "adGoodsId") {
                const addFormData = this.addFormData
                if (addFormData.rebateAppId && addFormData.adGoodsId && vailNumber(addFormData.adGoodsId)) {
                    let loadingInstance = Loading.service({
                        fullscreen: true,
                        lock: true,
                        text: '正在获取商品信息',
                        background: 'rgba(0, 0, 0, 0.5)'
                    });
                    this.$axios({
                        url: '/api/syn/rebateDataPlat/thirdplatGoods/tb/info',
                        data: {
                            rebateAppId: addFormData.rebateAppId,
                            goodsId: addFormData.adGoodsId
                        },
                        method: 'GET'
                    }).then((res) => {
                        loadingInstance.close()
                        const addFormData = { ...this.addFormData }
                        addFormData.goodsName = res.Data.goodsName
                        this.addFormData = addFormData
                    }).catch(() => {
                        loadingInstance.close()
                        const addFormData = { ...this.addFormData }
                        delete addFormData.goodsName
                        this.addFormData = addFormData
                    })
                } else {
                    const addFormData = { ...this.addFormData }
                    delete addFormData.goodsName
                    this.addFormData = addFormData
                }

            }
        },

        // 处理确定新增/编辑推广商品事件
        handleConfirm() {
            this.$refs['customerManage-form'].$refs['wf-form'].validate((valid) => {
                if (valid) {
                    const params = {
                        customerId: this.addFormData.customerId,
                        rebateAppId: this.addFormData.rebateAppId,
                        adGoodsId: this.addFormData.adGoodsId,
                        goodsName: this.addFormData.goodsName,
                        adPlatId: this.addFormData.adPlatId,
                        adReportOrderStatus: this.addFormData.adReportOrderStatus,
                        adReportEventId: this.addFormData.adReportEventId,
                        phAppIncId: this.addFormData.phAppIncId || "",
                        notes: this.addFormData.notes,
                        status: this.addFormData.status,
                    }
                    //adTjmH5Link: this.addFormData.adTjmH5Link,

                    if (this.addFormData.adTjmH5Link) {
                        const len = this.addFormData.adTjmH5Link.indexOf("&")
                        if (len > -1) {
                            const beforeStr = this.addFormData.adTjmH5Link.substring(0, len)
                            const laterStr = this.addFormData.adTjmH5Link.substring(len)
                            params.adTjmH5Link = beforeStr + encodeURIComponent(laterStr)
                        } else {
                            params.adTjmH5Link = this.addFormData.adTjmH5Link
                        }
                    }
                    if (this.addFormData.id) {   // 编辑
                        this.$axios({
                            url: '/api/syn/rebateDataPlat/goods/taobao/update',
                            data: {
                                id: this.addFormData.id,
                                ...params
                            },
                            method: 'POST'
                        }).then((res) => {
                            this.handleCancel()
                            this.getTableData()
                            Message.success('编辑推广商品成功')
                        })
                    } else {
                        this.$axios({
                            url: '/api/syn/rebateDataPlat/goods/taobao/add',
                            data: {
                                ...params
                            },
                            method: 'POST'
                        }).then((res) => {
                            this.handleCancel()
                            this.getTableData()
                            Message.success('新增推广商品成功')
                        })
                    }
                }
            })
        },

        // 处理搜索事件
        handleSearch() {
            this.current = 1
            this.getTableData()
        },

        // 点击新增按钮时触发
        handleClickAdd() {
            this.title = "新增推广商品"
            this.addFormData = {}
            const formRenderItem = { ...this.formRenderList[0] }
            formRenderItem.disabled = false
            this.$set(this.formRenderList, 0, formRenderItem)
            this.handleChangeAdPlatId()
            this.isShow = true
        },

        // 当前页改变时触发
        handleChangeCurrrent(current) {
            this.current = current
            this.getTableData()
        },

        // pageSize改变时触发
        handleChangePageSize(pageSize) {
            this.current = 1
            this.pageSize = pageSize
            this.getTableData()
        },

        // 处理搜索框改变时触发
        handleChangeSearchData(eventData) {
            const { data, item } = eventData
            this.searchData = data
        }
    }
}
</script>

<style lang="scss" scoped>
@media screen and (min-width: 768px) {
    .accountData {
        height: 100%;
        position: relative;
        display: flex;
        flex-direction: column;
        padding: 20px;
        background-color: #fff;
        .accountData-mobile {
            display: none;
        }
        .accountData-form {
            padding: 0 40px 0 22px;
        }
        .accountData-content {
            flex: 1;
        }
        .accountData-bottom {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
        }
        .table-edit {
            display: inline-flex;
            flex-direction: row;
            align-items: center;
            cursor: pointer;
            > img {
                width: 12px;
                height: 12px;
                margin-right: 7px;
            }
            > span {
                font-size: 12px;
            }
        }
    }
    .wf-form-item-tip {
        padding: 0px 4px;
        text-align: left;
        > * {
            max-width: 252px;
            overflow: hidden;
            white-space: normal;
            word-break: break-all;
            text-align: left;
            font-size: 12px;
        }
    }
    .ivu-poptip-arrow {
        position: absolute;
        top: 0px !important;
        transform: rotate(180deg);
    }
    .ivu-poptip-popper {
        top: 27px !important;
    }
}

@media screen and (max-width: 768px) {
    .accountData {
        height: 100%;
        display: flex;
        flex-direction: column;
        padding: 1.1rem 0 0;
        background-color: #f7f7f7;
        .wf-page {
            display: none;
        }
        .accountData-content {
            flex: 1;
        }
        .accountData-mobile {
            min-height: 100%;
            display: block;
            display: flex;
            flex-direction: column;
            padding: 0 0.3rem 0.3rem;
            overflow-y: auto;
            .table-content {
                overflow-x: auto;
            }
        }
        .accountData-form {
            padding: 0 0.4rem 0 0.4rem;
        }
        .table-edit {
            > img {
               width: .26rem;
               height: .26rem;
                margin-right: 7px;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/home/goodsInfo/taobao/index.vue